module.exports = __webpack_public_path__ + "static/media/pointer-enel.33810de8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pointer-enel.svg
// module id = 43
// module chunks = 0